import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana71Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <rect width="1221" height="921" fill="url(#pattern0_1465_19736)"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("1"))}  
  d="M243.217 474.885L274.708 473.625V520.231H224.322L243.217 474.885Z" 
  fill={getFillByLot(1, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("22"))}  
  d="M207.948 558.025L224.323 520.236H252.036V569.362H215.506C207.444 568.354 207.108 561.384 207.948 558.025Z" 
  fill={getFillByLot(22, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("21"))}  
  d="M292.341 568.102L252.032 569.362V520.236H291.081L292.341 568.102Z" 
  fill={getFillByLot(21, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("20"))}  
  d="M331.391 566.847L292.342 568.106L291.083 520.24L331.391 518.98V566.847Z" 
  fill={getFillByLot(20, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("2"))}  
  d="M318.795 472.373L274.708 473.633V518.98H318.795V472.373Z" 
  fill={getFillByLot(2, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("3"))}  
  d="M361.626 471.111L318.799 472.371V517.718H361.626V471.111Z" 
  fill={getFillByLot(3, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("19"))}  
  d="M370.441 565.587L331.392 566.847V518.98H370.441V565.587Z" 
  fill={getFillByLot(19, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("18"))}  
  d="M410.752 565.587H370.444V518.98H410.752V565.587Z" 
  fill={getFillByLot(18, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("4"))}  
  d="M405.711 469.854L361.624 471.113V517.72H405.711V469.854Z" 
  fill={getFillByLot(4, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("5"))}  
  d="M448.541 469.854H405.714V516.46H448.541V469.854Z" 
  fill={getFillByLot(5, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("6"))}  
  d="M491.367 468.592L448.54 469.851V515.198H491.367V468.592Z" 
  fill={getFillByLot(6, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("17"))}  
  d="M448.537 565.585V516.459H410.748V565.585H448.537Z" 
  fill={getFillByLot(17, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("16"))}  
  d="M490.108 564.323L448.54 565.583V515.197H491.367L490.108 564.323Z" 
  fill={getFillByLot(16, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("15"))}  
  d="M530.415 563.063L490.106 564.323L491.366 513.937L530.415 512.678V563.063Z" 
  fill={getFillByLot(15, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("7"))}  
  d="M536.713 512.677L491.366 513.937V468.59L536.713 467.33V512.677Z" 
  fill={getFillByLot(7, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("14"))}  
  d="M569.464 561.809L530.416 563.069V512.683L569.464 511.424V561.809Z" 
  fill={getFillByLot(14, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("13"))}  
  d="M608.511 560.544L569.462 561.803V511.418L608.511 510.158V560.544Z" 
  fill={getFillByLot(13, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("12"))}  
  d="M648.821 560.545H608.513V510.16L648.821 508.9V560.545Z" 
  fill={getFillByLot(12, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("11"))}  
  d="M684.786 560.545H648.821V508.9H677.792C681.991 517.298 690.137 534.093 694.167 544.17C697.315 552.039 694.011 556.835 690.613 559.159C688.927 560.312 686.828 560.545 684.786 560.545Z" 
  fill={getFillByLot(11, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("10"))}  
  d="M655.12 463.553L677.794 508.9H623.63L622.37 463.553H655.12Z" 
  fill={getFillByLot(10, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("9"))}  
  d="M579.54 464.812L622.368 463.553L623.627 508.9L580.8 510.159L579.54 464.812Z" 
  fill={getFillByLot(9, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <path 
  className="cursor-pointer"
  onClick={(e) => landSelector(e, findLandByLot("8"))}  
  d="M536.712 467.336L579.54 464.816L580.8 511.423L536.712 512.683V467.336Z" 
  fill={getFillByLot(8, selected, lands)}  
  fill-opacity="0.64" 
  stroke="#6D6859" 
  stroke-opacity="0.6"/>
  <defs>
  <pattern id="pattern0_1465_19736" patternContentUnits="objectBoundingBox" width="1" height="1">
  <use href="#image0_1465_19736" transform="matrix(0.0017278 0 0 0.0022906 -2.92461 -1.7238)"/>
  </pattern>
  <image id="image0_1465_19736"width="4096" height="2304" href="/mz2.png"/>
    </defs>
</svg>

  );
};
